// extracted by mini-css-extract-plugin
export default {"spacedMedium":"u0P3Gvtx","spacedLarge":"Ki9rklap"};